import client from './client';
import { clearTokens, setTokens } from './tokenStorage';

export const authApi = {
  async login(username, password) {
    const { data } = await client.post('/api/auth/login/', { username, password });
    setTokens({ access: data.access, refresh: data.refresh });
    return data;
  },

  async refresh(refreshToken) {
    const { data } = await client.post('/api/auth/token/refresh/', { refresh: refreshToken });
    setTokens({ access: data.access, refresh: data.refresh });
    return data;
  },

  async register(payload) {
    const { data } = await client.post('/api/auth/register/', payload);
    return data;
  },

  async forgotPassword(email) {
    const { data } = await client.post('/api/auth/forgot-password/', { email });
    return data;
  },

  async resetPassword(payload) {
    const { data } = await client.post('/api/auth/reset-password/', payload);
    return data;
  },

  async inviteSetupValidate(uid, token) {
    const { data } = await client.get('/api/auth/invite-setup/', { params: { uid, token } });
    return data;
  },

  async inviteSetupComplete(payload) {
    const { data } = await client.post('/api/auth/invite-setup/', payload);
    return data;
  },

  async changePassword(payload) {
    const { data } = await client.post('/api/auth/change-password/', payload);
    return data;
  },

  async me() {
    const { data } = await client.get('/api/auth/me/');
    return data;
  },

  logout() {
    clearTokens();
  },
};

export default authApi;